import dynamic from 'next/dynamic'
import React, { FC } from 'react'

import { BarProps } from '@Components/CMS/Bar/BarFactory/types'

const TallUrgencyBar = dynamic(() => import('@Components/CMS/Bar/BarFactory/Bars/Urgency/TallUrgencyBar/TallUrgencyBar'))
const SlimUrgencyBar = dynamic(() => import('@Components/CMS/Bar/BarFactory/Bars/Urgency/SlimUrgencyBar/SlimUrgencyBar'))

export const UrgencyBarFactory: FC<BarProps> = (props) => {
  const { bar } = props
  switch (bar.theme) {
    case 'campaign_small':
      return <SlimUrgencyBar {...props} />
    default:
      return <TallUrgencyBar {...props} />
  }
}
